import { features } from "../../constants";
import styles, { layout } from "../../css/style.js";
import Button from "./Button";

const FeatureCard = ({ icon, title, content, index }) => (
  <div className={`flex flex-row p-6 rounded-[20px] ${index !== features.length - 1 ? "mb-6" : "mb-0"} feature-card`}>
    <div className={`w-[64px] h-[64px] rounded-full ${styles.flexCenter} bg-dimBlue`}>
      <img src={icon} alt="star" className="w-[50%] h-[50%] object-contain" />
    </div>
    <div className="flex-1 flex flex-col ml-3">
      <h4 className="font-poppins font-semibold text-white text-[18px] leading-[23.4px] mb-1">
        {title}
      </h4>
      <p className="font-poppins font-normal text-dimWhite text-[16px] leading-[24px]">
        {content}
      </p>
    </div>
  </div>
);

const filteredFeatures = features.filter(feature => 
   feature.id === "feature-5" || feature.id === "feature-6"
);

const CardDeal = () => (
  <section className={layout.section}>
    <div className={layout.sectionInfo}>
      <h2 className={styles.heading2}>
      Din Gateway til Intelligent Investering
      </h2>
      <p className={`${styles.paragraph} max-w-[470px] mt-5`}>
      Udforsk markedets muligheder med vores intuitive platform. Vi kombinerer avanceret AI-teknologi med brugervenlige analyseværktøjer, så du nemt kan evaluere potentielle investeringer og beregne forventede afkast.

Platformen analyserer automatisk virksomheders nøgletal og giver dig præcise indsigter baseret på dine personlige investeringskriterier. Slip for komplekse beregninger og få mere tid til det vigtigste - at træffe velinformerede investeringsbeslutninger.
      </p>

      <Button styles={`mt-10`} />
    </div>

    <div className={`${layout.sectionImg} flex-col`}>
      {filteredFeatures.map((feature, index) => (
        <FeatureCard key={feature.id} {...feature} index={index} />
      ))}
    </div>
  </section>
);

export default CardDeal;